'use strict';

var i18n = require('utils/i18n');
var Notification = require('utils/notification');
var StringUtils = require('utils/strings');
var Validator = require('utils/validation');

// the MultiInputView manages an inputfield based on the bootstrap tagsinput.
// Each input may be validated, and lists of tags can be copy-pasted
// If the tags are sent to the Backend an array of failed tags can be returned. In this case,
// the tag list will be reduced to the failed tags.
var MultiInputView = Marionette.ItemView.extend({
    template: require('components/common/templates/multi_input'),

    events: {
        'itemAdded input': 'itemAdded',
        'itemRemoved input': 'itemRemoved',
        'beforeItemAdd input': 'cancelInvalidInput',
    },

    initialize: function (options) {
        this.validationMethod =
            options.validation ||
            function () {
                return [];
            };
        this.selectID = options.selectID || 'js-multi-input';
        this.placeholder = options.placeholder || i18n.TR('Tag');
        this.items = options.items || [];
        this.error200Text = options.error200Text || i18n.TR('Einige Freigaben wurden erfolgreich verschickt');
        this.error400Text = options.error400Text || i18n.TR('Fehlerhafte Eingabe');
        this.error500Text = options.error500Text || i18n.TR('Anfrage fehlgeschlagen');
        this.partialSuccessText = options.partialSuccessText || i18n.TR('Anfrage(n) erfolgreich');

        this.cbAddElement = options.cbAddElement;
        this.cbRemoveElement = options.cbRemoveElement;

        // if specified, is expected to be the unaltered http-response from a server
        this.error = undefined;
    },

    serializeData: function () {
        this.prepareResponse();
        return {
            hasItems: this.items.length > 0,
            name: this.options.name || '',
            selectID: this.options.selectID,
            error: this.error,
            successfullRequests: this.successfullRequests,
            partialSuccessText: this.partialSuccessText,
            placeholder: this.placeholder,
            severity: this.severity,
            readOnly: this.options.readOnly,
        };
    },

    onAttach: function () {
        this.initializeMultiInput();
    },

    onRender: function () {
        this.initializeMultiInput();
    },

    validate: function () {
        var items = $('#' + this.selectID).tagsinput('items');
        var allItemsValid = items.length > 0;
        _.each(
            items,
            function (item) {
                allItemsValid = allItemsValid && this.validationMethod(item).length === 0;
            },
            this
        );
        return allItemsValid;
    },

    initializeMultiInput: function () {
        var self = this;
        $('#' + this.selectID).tagsinput({
            maxChars: 10000,
            trimValue: true,
            delimiterRegex: this.options.delimiter || /[;,\s]+/,
            confirmKeys: [13, 44],
            tagClass: function (item) {
                var classes = 'tag label label-block ' + (self.options.colorClass || 'label-groups');
                // invalid input? -> highlight invalid tag
                if (StringUtils.containsSpecialChars(item) || self.validationMethod(item).length !== 0) {
                    classes += ' invalid';
                }
                return classes;
            },
        });

        // already have some items? -> add them on initialization
        $('#' + this.selectID).tagsinput('add', this.items.join(';'));
        if (this.options.readOnly) {
            var $tb = $(this.$el).find('div.bootstrap-tagsinput > input');
            $tb.attr('readonly', 'readonly');
        }
    },

    cancelInvalidInput: function (event) {
        event.cancel = StringUtils.containsSpecialChars(event.item);
        if (event.cancel) {
            Notification.show(
                'warning',
                i18n.TR('Fehler'),
                i18n.TR('Ungültiges Zeichen gefunden, Eingabe wird verworfen.')
            );
        }
    },

    prepareResponse: function () {
        this.successfullRequests = undefined;
        this.error = undefined;
        var response = this.options.response;
        if (!response) {
            return;
        }
        if (response.responseText && response.responseText.trim() == 'sending_email_failed') {
            this.error = i18n.TR(
                'Das Versenden der E-Mails ist fehlgeschlagen, bitte versuchen Sie es zu einem späteren Zeitpunkt erneut.'
            );
            return;
        }

        if (typeof response === 'string' || (response.responseJSON === undefined && response.responseText)) {
            this.error = response.responseText || response;
            return;
        }

        var invalidItems = response.responseJSON;
        var itemCount = this.items.length;
        // already have a list and (backend) errors? -> only keep items with errors
        if (itemCount > 0 && Array.isArray(invalidItems)) {
            this.items = _.intersection(invalidItems, this.items);
            this.successfullRequests = itemCount - invalidItems.length;
        }

        // user error
        if (response.status && typeof response.status === 'number') {
            var statusType = Math.round(response.status / 100);
            switch (statusType) {
                case 2:
                    if (itemCount > 0 && Array.isArray(invalidItems)) {
                        this.error = this.error200Text;
                        this.severity = 'warning';
                    }
                    break;
                case 4:
                    this.error = this.error400Text;
                    break;
                case 5:
                    this.error = this.error500Text;
                    break;
            }
        } else {
            this.error = response.responseText || '';
        }
    },

    getItems: function () {
        return $('#' + this.selectID).tagsinput('items');
    },

    addItem: function (i) {
        $('#' + this.selectID).tagsinput('add', i);
    },

    itemAdded: function (event) {
        $(event.currentTarget).siblings('div.bootstrap-tagsinput').children().attr('placeholder', '');

        if (this.cbAddElement) {
            this.cbAddElement(event);
        }
    },

    itemRemoved: function (event) {
        if (this.getItems().length === 0) {
            $(event.currentTarget).siblings('div.bootstrap-tagsinput').children().attr('placeholder', this.placeholder);
        }

        if (this.cbRemoveElement) {
            this.cbRemoveElement(event);
        }
    },
});

function GetMultiEmailView(options) {
    var defaultOptions = {
        selectID: 'js-email-input',
        validation: Validator.validateEmail,
        placeholder: i18n.TR('E-Mails'),
        items: [],
        partialSuccessText: i18n.TR('Freigab(en) erfolgreich verschickt.'),
    };
    return new MultiInputView($.extend(defaultOptions, options));
}

module.exports = {
    View: MultiInputView,
    GetMultiEmailView: GetMultiEmailView,
};
